import React, { useState } from 'react';
import './../../core/style/FooterSection.css';
import Toast from '../../Shared/Components/toaster/Toast'; 

const FooterSection = () => {
  const currentYear = new Date().getFullYear();

  const [toastConfig, setToastConfig] = useState({ show: false, type: 'success', title: '', message: '' });

  const trustLogos = [
    { label: "24 Hour Service", img: "/images/24hour.png" },
    { label: "Best Service", img: "/images/bestService.png" },
    { label: "1 Year Warranty", img: "/images/iyear.png" },
    { label: "100% Satisfaction", img: "/images/guarantee.png" },
    { label: "Made In India", img: "/images/make.png" }
  ];

  const handleDownload = async (e) => {
    e.preventDefault();
    
    const fileUrl = '/docs/busan_brochure.pdf';
    const fileName = 'Busan_Hydraulic_Breaker_Brochure.pdf';

    try {
      const response = await fetch(fileUrl);
      const contentType = response.headers.get('content-type');
      if (!response.ok || (contentType && contentType.includes('text/html'))) {
        throw new Error('Invalid file payload asset response');
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      setToastConfig({
        show: true,
        type: 'success',
        title: 'Download Successful',
        message: 'Product brochure has been saved to your device.'
      });

    } catch (error) {
      setToastConfig({
        show: true,
        type: 'error',
        title: 'Download Failed',
        message: 'Brochure is temporarily updating. Please message us on WhatsApp for specs!'
      });
    }
  };

  const sections = [
    {
      title: "Explore",
      items: [
        { label: "Home", url: "/" },
        { label: "Products", url: "#catalog" },
        { label: "Technical Details", url: "#specs" },
        { label: "Guidance", url: "#guidance" }
      ]
    },
    {
      title: "Capabilities",
      items: [
        { label: "Hydraulic Breakers", url: "#catalog" },
        { label: "Heavy-Duty Attachments", url: "#catalog" },
        { label: "Excavator Integration", url: "#catalog" },
        { label: "Precision Engineering", url: "#catalog" }
      ]
    },
    {
      title: "Company",
      items: [
        { label: "About", url: "#about" },
        { label: "Help & FAQ", url: "#help" },
        { label: "Contact", url: "#contact" },
        { label: "Legal & Consent", url: "#legal" }
      ]
    }
  ];

  return (
    <>
      <Toast 
        show={toastConfig.show} 
        type={toastConfig.type} 
        title={toastConfig.title} 
        message={toastConfig.message} 
        onClose={() => setToastConfig(prev => ({ ...prev, show: false }))} 
      />

      <footer className="footer-container" id='about'>
        <div className="footer-content">
          <div className="footer-branding">
            <div className="footer-logo">Busan Hydraulic Rock Breaker for JCB & Excavators</div>
            <h2 className="footer-large-desc">
              Technical equipment supplier for <br /> heavy-duty Busan rock breaker and hydraulic quick coupler.
            </h2>
            <div className="footer-subtitle">
              <span className="footer-accent">•</span> Serving Global Mining & Construction Leaders.
            </div>
          </div>

          <div className="footer-grid">
            {sections.map((section, index) => (
              <div key={index} className="footer-col">
                <h4 className="footer-col-header">{section.title}</h4>
                <ul className="footer-link-list">
                  {section.items.map((item, idx) => (
                    <li key={idx}>
                      <a href={item.url}>{item.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            
            <div className="footer-col">
              <h4 className="footer-col-header">Resources</h4>
              <ul className="footer-link-list">
                <li>
                  <a href="#download" onClick={handleDownload}>
                    Download Brochure
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="footer-data-contact" id='contact'>
            <h4 className="footer-col-header">Industrial Data / Contact</h4>
            <div className="contact-item">
              <strong>Headquarters:</strong>
            <a href='https://maps.app.goo.gl/H2WNsfLrJpPLXVC89' target='blank'>Bhuj bhachu, Om Nagar, Anjar, Gujarat 370110, India</a>
            </div>
            <div className="contact-item-row">
              <div className="contact-item">
                <strong>Support (Mobile):</strong>
                <a href="tel:+919825134269">+91 98251 34269</a><br />
                <a href="tel:+917567910215">+91 75679 10215</a>
              </div>
              <div className="contact-item">
                <strong>Technical Inquiry (Email):</strong>
                <a href="mailto:hardikaent2017@gmail.com">hardikaent2017@gmail.com</a>
              </div>
              <div className="footer-section social-section contact-item">
                <strong>CONNECT WITH US</strong>
                <div className="social-icons">
                  <a href="https://www.facebook.com/share/17cDp5JEs1/" target="_blank" rel="noopener noreferrer" className="social-link facebook" title="Facebook">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/busan_555?utm_source=qr&igsh=a2tyN241eG43azhv" target="_blank" rel="noopener noreferrer" className="social-link instagram" title="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                  <a href="https://youtube.com/@busanhydraulicbreaker?si=DGpx6yXieSouekvG" target="_blank" rel="noopener noreferrer" className="social-link youtube" title="YouTube">
                    <i className="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-trust-section">
          <div className="trust-grid">
            {trustLogos.map((logo, index) => (
              <div key={index} className="trust-item">
                <img
                  src={logo.img}
                  alt={logo.label}
                  className="trust-logo-img"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="footer-banner-container" id='legal'>
          <div className="footer-banner-overlay"></div>
          <div className="footer-banner-text">SUPREME RELIABILITY</div>
          <div className="footer-copyright">
            © {currentYear} Busan Hydraulic Breaker. All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default FooterSection;